import styled from "styled-components";

export const ProductContainer = styled("div")`
  padding: 1rem;
  border-radius: 1rem;
`;

export const Title = styled("h4")`
  height: 100%;
`;

export const CartProduct = styled("div")`
  display: flex;
  text-align: center;
  justify-content: center;
  gap: 1rem;
`;

export const HeaderItem = styled("div")`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;
